export default __webpack_public_path__ + "static/turning-the-page-end-page-place-holder-image-aa79deacfeedcaab084b082ea47fb236.png";